var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-center"},[_vm._v(" "+_vm._s(void _vm.notify())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }